import type { PixelConfig } from "./types.js";

function findOwnScript(): HTMLScriptElement | null {
  const cs = document.currentScript as HTMLScriptElement | null;
  if (cs && cs.src) return cs;
  const scripts = document.scripts;
  for (let i = scripts.length - 1; i >= 0; i--) {
    const s = scripts[i];
    if (s && s.src && /pixel\.js(\?|$)/.test(s.src)) return s;
  }
  return null;
}

function deriveCollectorBase(scriptUrl: URL, override: string | null): string {
  if (override && override.length > 0) return override.replace(/\/$/, "");
  const host = scriptUrl.host;
  // pixel.<rest> -> collect.<rest>
  if (host.startsWith("pixel.")) {
    const rest = host.slice("pixel.".length);
    return `${scriptUrl.protocol}//collect.${rest}`;
  }
  // dev / fixture: same origin
  return `${scriptUrl.protocol}//${host}`;
}

export function readConfig(): PixelConfig | null {
  if (typeof document === "undefined") return null;
  const script = findOwnScript();
  if (!script || !script.src) return null;
  let url: URL;
  try {
    url = new URL(script.src, location.href);
  } catch {
    return null;
  }
  const pid = url.searchParams.get("pid");
  if (!pid) return null;
  const override = script.getAttribute("data-collector");
  const collectorBase = deriveCollectorBase(url, override);
  return { pixelId: pid, collectorBase };
}
